import { useState } from 'react';
import { NavLink, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { logoutUser } from '../../api/request';
import StatisticsPage from './sub/StatisticsPage';
import VisitorDashboard from './sub/VisitorDashboard';
import LogsPage from './sub/LogsPage';
import UsersPage from './sub/UsersPage';
import EditingPage from './sub/EditingPage';
import ImagesPage from './sub/ImagesPage';
import ProfilePage from './sub/ProfilePage';
import './adminPanel.css';

export default function AdminPanel() {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logoutUser();
      document.cookie = 'jwt=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const toggleDrawer = () => setDrawerOpen(prev => !prev);

  const SidebarContent = (
    <>
      <h2 className="sidebar-title">Haram Taxi AS Admin Panel</h2>
      <nav className="sidebar-nav">
        <NavLink to="/admin/statistics" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Statistics</NavLink>
        <NavLink to="/admin/logs" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Logs</NavLink>
        <NavLink to="/admin/users" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Users</NavLink>
        <NavLink to="/admin/edit-pages" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Page editor</NavLink>
        <NavLink to="/admin/images" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Image storage</NavLink>
        <a href="https://webmail.haramtaxiogbuss.no" target="_blank" rel="noopener noreferrer" className="nav-link">Mail</a>
        <NavLink to="/admin/profile" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Profile</NavLink>
      </nav>
      <button onClick={handleLogout} className="logout-button">Logout</button>
    </>
  );

  return (
    <div className="admin-panel">
      <aside className={`admin-sidebar ${drawerOpen ? 'open' : ''}`}>
        {SidebarContent}
      </aside>
            <aside className={`admin-filler-sidebar ${drawerOpen ? 'open' : ''}`}>
        {}
      </aside>

      {/* Wrapper handles flex layout on desktop and stacking on mobile */}
      <div className="mobile-content-wrapper">
        <div className="mobile-top-bar">
          <button className="mobile-burger" onClick={toggleDrawer}>☰</button>
        </div>

        <main className="admin-content" onClick={() => drawerOpen && setDrawerOpen(false)}>
          <Routes>
            <Route path="/" element={<Navigate to="/admin/statistics" replace />} />
            <Route path="/admin/statistics" element={<VisitorDashboard />} />
            <Route path="/admin/logs" element={<LogsPage />} />
            <Route path="/admin/users" element={<UsersPage />} />
            <Route path="/admin/edit-pages/*" element={<EditingPage />} />
            <Route path="/admin/images" element={<ImagesPage />} />
            <Route path="/admin/profile" element={<ProfilePage />} />
          </Routes>
        </main>
      </div>

      {drawerOpen && <div className="sidebar-overlay" onClick={toggleDrawer}></div>}
    </div>
  );
}
